module.exports = __webpack_public_path__ + "img/yale-logo.def60000.png";